import { Client } from '../common';

export async function searchPreferences(payload, options) {
  const { category } = payload;

  return await Client.request({
    method: 'POST',
    url: 'user-preference/preferences/search/user-preferences',
    body: { filters: { category } },
    ...options
  });
}

export async function createPreference(payload, options) {
  return await Client.request({
    method: 'POST',
    url: 'user-preference/preferences',
    body: payload,
    ...options
  });
}

export async function getPreference(payload, options) {
  const { preferenceId } = payload;

  return await Client.request({
    method: 'GET',
    url: `user-preference/preferences/${preferenceId}`,
    ...options
  });
}

export async function updatePreference(payload, options) {
  const { preferenceId, ...rest } = payload;

  return await Client.request({
    method: 'PATCH',
    url: `user-preference/preferences/${preferenceId}`,
    body: rest,
    ...options
  });
}

export async function deletePreference(payload, options) {
  const { preferenceId } = payload;

  return await Client.request({
    method: 'DELETE',
    url: `user-preference/preferences/${preferenceId}`,
    ...options
  });
}

export async function recoverPreference(payload, options) {
  const { preferenceId } = payload;

  return await Client.request({
    method: 'PATCH',
    url: `user-preference/preferences/${preferenceId}/recover`,
    ...options
  });
}
